import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import YearsFormPart from "../years-form-part"
import * as Conf from "../../configuration"
import ViewGlossaryModal from "../../../glossary-modal"
import * as Model from "../../../../model"

export default class GeneralitiesFormPart
extends React.Component<Props, State> {
	private readonly fileReader: FileReader = new FileReader()
	private fileInput: HTMLInputElement
	private endOffset = 1
	private startOffset = 6

	componentDidUpdate(
		_prevProps: Readonly<Props>,
		prevState: Readonly<State>
	): void {
		if (this.state.enableLogo && this.state.enableLogo !== prevState.enableLogo) {
			this.fileInput && this.fileInput.click()
		}
	}

	constructor(props: Props) {
		super(props)

		const currentYear = new Date().getFullYear()
		this.state = {
			enableDate: false,
			enableLogo: false,
			enableRoundValues: false,
			enableHideZeroLines: false,
			enableSubtitle: false,
			enableTitle: false,
			displayGlossary: false,
			logo: null,
			referenceYear: currentYear - 1,
			yearEnd: currentYear - this.endOffset,
			yearStart: currentYear - this.startOffset
		}

		this.initFileReader()
	}

	render() {
		return <section className="section">
		<h2 className="title">Généralités</h2>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					name={Names.Summary}
					onChange={e => this.handleInputChange(e)}
					checked={ this.props.report && this.props.report.includes(Names.Summary)}
					type="checkbox" /> Sommaire
				</label>
			</div>
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					name={Names.Glossary}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Glossaire
				</label>
				&nbsp;				
			</div>
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					checked={this.state.enableTitle}
					name={Names.TitleEnabled}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Titre
				</label>
			</div>

			{this.state.enableTitle && <div className="control">
				<input
				className="input"
				defaultValue="Rapport de gestion par défaut"
				name={Names.Title}
				type="text" />
			</div>}
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					checked={this.state.enableSubtitle}
					name={Names.SubtitleEnabled}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Sous-titre
				</label>
			</div>
			{this.state.enableSubtitle && <div className="control">
				<input className="input" name={Names.Subtitle} type="text" />
			</div>}
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					checked={this.state.enableDate}
					name={Names.DateEnabled}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Date
				</label>
			</div>

			{this.state.enableDate && <div className="control">
				<input
				className="input"
				defaultValue={(new Date()).toISOString().substr(0, 10)}
				name={Names.Date}
				type="date" />
			</div>}
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					name={Names.Pagination}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Pagination
				</label>
			</div>
		</div>

		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					checked={this.state.enableLogo}
					name={Names.LogoEnabled}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Logo

					{this.state.enableLogo && <div className="file has-name is-boxed">
						<label className="file-label">
							<input
							className="file-input"
							name={Names.LogoPath}
							type="file"
							onChange={e => this.handleLogoChange(e)}
							ref={i => this.fileInput = i} />

							<span className="file-cta">
								<FontAwesomeIcon icon="upload" />
								<span className="file-label">Choisir une image…</span>
							</span>

							{this.state.logo && <span className="file-name">
								<img src={this.state.logo.data} />

								<input
								name={Names.LogoData}
								type="hidden"
								value={this.state.logo.data} />

								<input
								name={Names.LogoHeight}
								type="hidden"
								value={this.state.logo.height} />

								<input
								name={Names.LogoWidth}
								type="hidden"
								value={this.state.logo.width} />
							</span>}
						</label>
					</div>}
				</label>
			</div>
		</div>

		{/* Arrondir les valeurs */}
		<div className="field">
			<div className="control">
				<label className="checkbox">
					<input
					checked={this.state.enableRoundValues}
					name={Names.RoundnessEnabled}
					onChange={e => this.handleInputChange(e)}
					type="checkbox" /> Arrondir les valeurs
				</label>
			</div>

			{this.state.enableRoundValues && <div className="control">
				<div className="select is-fullwidth">
					<select name={Names.Roundness}>
						{RoundValuesOptions.map((opt, i) =>
						<option key={i} value={opt.value}>{opt.label}</option>)}
					</select>
				</div>
			</div>}
		</div>
		{/* Fin Arrondir les valeurs */}

		{/* Cacher les lignes a zero */}
		<div className="field">
			<div className="control">
				<label className="checkbox">
				<input
					checked={this.state.enableHideZeroLines}
					name={Names.HideZeroLinesEnabled}
					onChange={(e) => this.handleInputChange(e)}
					type="checkbox"
				/>{' '}
				Cacher les lignes sans valeurs
				</label>
			</div>
		</div>
        {/* Fin cacher ligne a zero */}

		<YearsFormPart
		end={this.state.yearEnd}
		endInputName={Names.Years.End}
		start={this.state.yearStart}
		startInputName={Names.Years.Start}
		onChange={(year, limit) => this.handleYearChange(year, limit)}/>

		<div className="field">
			<label className="label" htmlFor={Names.ReferenceYear}>
				Année de référence
			</label>

			<div className="control">
				<input
				className="input"
				id={Names.ReferenceYear}
				name={Names.ReferenceYear}
				type="number"
				value={this.state.referenceYear}
				onChange={e => this.handleInputChange(e)}/>
			</div>
		</div>

		{this.state.displayGlossary &&
			<ViewGlossaryModal
			localAuthority={this.props.localAuthority}
			onClickCloseButton={e => this.handleCloseGlossaryModal(e)}
			onClickFooterButton={(_b, e) => this.handleCloseGlossaryModal(e)} />}
	</section>
	}

	private handleClickViewGlossary(e: React.SyntheticEvent<Element>): void {
		this.setState({ displayGlossary: true })
	}

	private handleCloseGlossaryModal(e: React.SyntheticEvent<Element>): void {
		e.preventDefault()
		this.setState({ displayGlossary: false })
	}

	private handleInputChange(e: React.SyntheticEvent<Element>): void {
		const input = e.target as HTMLInputElement

		switch (input.name) {
			case Names.DateEnabled:
				this.setState({ enableDate: input.checked })
				break
			case Names.LogoEnabled:
				this.setState({ enableLogo: input.checked })
				break
			case Names.ReferenceYear:
				this.setState(prevState => {
					const referenceYear = parseInt(input.value)
					return {
						referenceYear,
						yearEnd: referenceYear > prevState.yearEnd
						? referenceYear
						: prevState.yearEnd,
						yearStart: referenceYear < prevState.yearStart
						? referenceYear
						: prevState.yearStart
					}
				})
				break
			case Names.RoundnessEnabled:
				this.setState({ enableRoundValues: input.checked })
				break
			case Names.SubtitleEnabled:
				this.setState({ enableSubtitle: input.checked })
				break
			case Names.TitleEnabled:
				this.setState({ enableTitle: input.checked })
				break
			case Names.HideZeroLinesEnabled:
				this.setState({ enableHideZeroLines: input.checked });
				break;
		}
	}

	private handleLogoChange(e: React.SyntheticEvent<Element>): void {
		const fileInput = e.target as HTMLInputElement

		if (!fileInput || Names.LogoPath !== fileInput.name) return

		if (fileInput.files.length)
			this.fileReader.readAsDataURL(fileInput.files[0])
		else this.setState({ logo: null })
	}

	private handleYearChange(
		year: number,
		limit: "start" | "end"
	): void {
		this.setState(prevState => {
			const prevRefYear = prevState.referenceYear
			const prevYearEnd = prevState.yearEnd
			const prevYearStart = prevState.yearStart

			return {
				referenceYear:
					"end" === limit && year < prevRefYear ? year :
					"start" === limit && year > prevRefYear ? year :
					prevRefYear,
				yearEnd:
					"end" === limit ? year :
					"start" === limit && year > prevYearEnd ? year :
					prevYearEnd,
				yearStart:
					"start" === limit ? year :
					"end" === limit && year < prevYearStart ? year :
					prevYearStart
			}
		})
	}

	private initFileReader(): void {
		this.fileReader.onload = () => {
			const image = new Image()
			const data = this.fileReader.result as string

			image.onload = () => {
				this.setState({ logo: {
					data,
					height: image.height,
					width: image.width
				}})
			}

			image.src = data
		}
	}
}

export const Names = {
	Date: "generalities-date",
	DateEnabled: "generalities-date-enabled",
	Glossary: "generalities-glossary",
	LogoData: "generalities-logo-data",
	LogoEnabled: "generalities-logo-enabled",
	LogoHeight: "generalities-logo-height",
	LogoPath: "generalities-logo-path",
	LogoWidth: "generalities-logo-width",
	Pagination: "generalities-pagination",
	ReferenceYear: "generalities-reference-year",
	Roundness: "generalities-roundness",
	RoundnessEnabled: "generalities-roundness-enabled",
	HideZeroLinesEnabled: 'generalities-hidezerolines-enabled',
	Subtitle: "generalities-subtitle",
	SubtitleEnabled: "generalities-subtitle-enabled",
	Summary: "generalities-summary",
	Title: "generalities-title",
	TitleEnabled: "generalities-title-enabled",
	Years: {
		End: "generalities-years-end",
		Start: "generalities-years-start"
	}
}

export const RoundValuesOptions: RoundValuesOption[] = [
	{ label: "à l'entier le plus proche", value: "nearest-whole-number" },
	{ label: "en k€", value: "nearest-thousand" }
]

export interface Props {
	loading?: boolean
	localAuthority: Model.LocalAuthority
	report?: any
}

interface RoundValuesOption {
	label: string
	value: Conf.RoundnessValue
}

interface State {
	enableDate: boolean
	enableLogo: boolean
	enableRoundValues: boolean
	enableHideZeroLines: boolean;
	enableSubtitle: boolean
	enableTitle: boolean
	displayGlossary: boolean
	logo: {
		data: string
		height: number
		width: number
	}
	referenceYear: number,
	yearEnd: number
	yearStart: number
}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/generalities-form-part/index.tsx